<template>
  <div :class="`as-performance ${modifyClass} as-half-time`">
    <div class="as-performance__head">
      <IconPerformanceHalfTime />
      <span> Phong độ hiệp 1/2 </span>
    </div>
    <div class="as-performance__body">
      <FootballTeamItem
        :footyStats="footyStats"
        :match="match"
        modifyClass="as-vertical"
        :showName="false"
        :showResult="false"
        :showState="true"
        :homePoint="homePoint"
        :awayPoint="awayPoint"
      />
      <div class="as-vs">
        <div class="as-vs__tile">HT - Overall</div>
        <div class="as-vs__line">
          <div class="as-vs-line-item">
            <div class="as-vs-line-item__main"></div>
            <div class="as-vs-line-item__percent"></div>
            <div class="as-vs-line-item__ball">
              <div class="as-icon">
                <IBall />
              </div>
            </div>
          </div>
        </div>
        <div v-if="homePoint > 0 || awayPoint > 0" class="as-vs__text">
          <span class="as-bold">{{ homePoint > awayPoint ? footyStats?.home_name : footyStats?.away_name }}</span> có
          <span class="as-green">{{ getPercentByPoint(homePoint, awayPoint) }}%</span> phong độ tốt hơn<br />
          <span class="as-bold">{{  homePoint > awayPoint ? footyStats?.away_name : footyStats?.home_name }}</span> trong hiệp 1
        </div>
      </div>
      <FootballTeamItem
        :footyStats="footyStats"
        :match="match"
        modeTeam="as-away"
        modifyClass="as-vertical"
        :showName="false"
        :showResult="false"
        :showState="true"
        :homePoint="homePoint"
        :awayPoint="awayPoint"
      />
    </div>
    <div class="as-competition">
      <table class="as-competition__table">
        <thead>
          <tr>
            <th>Phong độ H1/H2</th>
            <th class="as-center a">{{ footyStats?.home_name }}</th>
            <th class="as-center a">{{ footyStats?.away_name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Thắng % Hiệp 1</td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('home', 'firstGoalScoredPercentage_away')
              )}`"
            >
              {{ getValueWithMode("home", "firstGoalScoredPercentage_away") }}%
            </td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('away', 'firstGoalScoredPercentage_away')
              )}`"
            >
              {{ getValueWithMode("away", "firstGoalScoredPercentage_away") }}%
            </td>
          </tr>
          <tr>
            <td>Thắng % Hiệp 2</td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('home', 'wins_2hg_percentage_overall')
              )}`"
            >
              {{ getValueWithMode("home", "wins_2hg_percentage_overall") }}%
            </td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('away', 'wins_2hg_percentage_overall')
              )}`"
            >
              {{ getValueWithMode("away", "wins_2hg_percentage_overall") }}%
            </td>
          </tr>
          <tr>
            <td>Hòa % Hiệp 1</td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('home', 'drawingAtHTPercentage_overall')
              )}`"
            >
              {{ getValueWithMode("home", "drawingAtHTPercentage_overall") }}%
            </td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('away', 'drawingAtHTPercentage_overall')
              )}`"
            >
              {{ getValueWithMode("away", "drawingAtHTPercentage_overall") }}%
            </td>
          </tr>
          <tr>
            <td>Hòa % Hiệp 2</td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('home', 'draws_2hg_percentage_overall')
              )}`"
            >
              {{ getValueWithMode("home", "draws_2hg_percentage_overall") }}%
            </td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('away', 'draws_2hg_percentage_overall')
              )}`"
            >
              {{ getValueWithMode("away", "draws_2hg_percentage_overall") }}%
            </td>
          </tr>
          <tr>
            <td>Thua % Hiệp 1</td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('home', 'trailingAtHTPercentage_overall')
              )}`"
            >
              {{ getValueWithMode("home", "trailingAtHTPercentage_overall") }}%
            </td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('away', 'trailingAtHTPercentage_overall')
              )}`"
            >
              {{ getValueWithMode("away", "trailingAtHTPercentage_overall") }}%
            </td>
          </tr>
          <tr>
            <td>Thua % Hiệp 2</td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('home', 'losses_2hg_percentage_overall')
              )}`"
            >
              {{ getValueWithMode("home", "losses_2hg_percentage_overall") }}%
            </td>
            <td
              :class="`as-center ${getClassForItem(
                getValueWithMode('away', 'losses_2hg_percentage_overall')
              )}`"
            >
              {{ getValueWithMode("away", "losses_2hg_percentage_overall") }}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { IMatch } from "~src/interfaces";
import FootballTeamItem from "~src/components/foot_stats/FootballTeamItem.vue";
import IconPerformanceHalfTime from "~src/components/icons/foot_stats/IconPerformanceHalfTime.vue";
import IBall from "~src/components/icons/incident/IBall.vue";
import type {
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { computed } from "vue";
import { getClassForItem, getPercentByPoint } from "~src/helpers/footystats";

interface Props {
  match: IMatch;
  modifyClass?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

const props = withDefaults(defineProps<Props>(), {
  modifyClass: "",
});

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const homePoint = computed<number>(() => {
  return homeTeamLastX.value?.stats?.HTPPG_overall ?? 0;
});

const awayPoint = computed<number>(() => {
  return awayTeamLastX.value?.stats?.HTPPG_overall ?? 0;
});

const getValueWithMode = (team = "home", mode = "btts", half = 1) => {
  const __data: IStatsParent =
    team === "home" ? homeTeamLastX.value : awayTeamLastX.value;
  if (
    !__data ||
    !__data.stats ||
    !__data.stats.hasOwnProperty(mode)
  ) {
    return 0;
  }

  return __data.stats[mode] as number;
};
</script>

<script lang="ts">
export default {};
</script>
